import type { TaskCardDemoRow } from '@/app/[locale]/tasks/components/TasksTaskCards/tasksTaskCards.constants'
import { URLS } from '@/configs/urls'

export type TaskCardCta = 'watch' | 'share' | 'action' | 'create'

export function mapTaskTypeToCta(type: string | undefined): TaskCardCta {
  const normalized = (type ?? '').trim().toLowerCase()
  if (normalized === 'share') {
    return 'share'
  }
  if (normalized === 'action') {
    return 'action'
  }
  if (normalized === 'create') {
    return 'create'
  }
  return 'watch'
}

export function getTaskCardCtaLabelKey(
  cta: TaskCardCta
): 'watchCta' | 'shareCta' | 'actionCta' | 'createCta' {
  if (cta === 'share') {
    return 'shareCta'
  }
  if (cta === 'action') {
    return 'actionCta'
  }
  if (cta === 'create') {
    return 'createCta'
  }
  return 'watchCta'
}

export function getTaskCardDemoTitle(
  cta: TaskCardCta
): 'watch' | 'share' | 'action' | 'create' {
  if (cta === 'share') {
    return 'share'
  }
  if (cta === 'action') {
    return 'action'
  }
  if (cta === 'create') {
    return 'create'
  }
  return 'watch'
}

export function getTaskCardDetailPath(
  row: TaskCardDemoRow,
  opts?: { view?: 'closed' }
): string | null {
  if (row.cta === 'watch') {
    return URLS.TASK_WATCH(row.id, opts)
  }
  if (row.cta === 'share') {
    return URLS.TASK_SHARE(row.id, opts)
  }
  if (row.cta === 'action') {
    return URLS.TASK_ACTION(row.id, opts)
  }
  if (row.cta === 'create') {
    return URLS.TASK_CREATE(row.id, opts)
  }
  return null
}

export function getTaskSelectAnalyticsEvent(
  cta: TaskCardCta
): 'watch_task_select' | 'share_task_select' | 'action_task_select' | null {
  if (cta === 'watch') {
    return 'watch_task_select'
  }
  if (cta === 'share') {
    return 'share_task_select'
  }
  if (cta === 'action') {
    return 'action_task_select'
  }
  return null
}
